import { createSelector } from "@reduxjs/toolkit";

import type { ITreeStructure } from "@/shop/types/tree";

import type { ITreeReducerState } from "./types";

const getPartTreeState = (state: { partTree: ITreeReducerState }): ITreeReducerState => state.partTree;

export const getPartTreeData = createSelector(getPartTreeState, (state) => state.trees);

export const getPartTreeIsFetching = createSelector(getPartTreeState, (state) => state.isFetching);

export const getPartTreeHasError = createSelector(getPartTreeState, (state) => state.hasError);

export const getPartTree = (state: { partTree: ITreeReducerState }, treeUrl: string): ITreeStructure => getPartTreeData(state)[treeUrl]!;

export const getPartTreeExists = (state: { partTree: ITreeReducerState }, treeUrl: string): boolean => getPartTreeIsFetching(state)[treeUrl] != null;
// export const getPartTreeExists = state => url => !!(getPartTreeData(state)[url] || getPartTreeIsFetching(state)[url] || getPartTreeHasError(state)[url]);
